import React from 'react';
import { Image, Rect } from 'react-konva';
// import { isDevelopment, } from '../../library/constants';
import { shrinkDimBy } from '../../library/calc';

const moveDown = .7;

export class Dna extends React.Component { //https://binf.snipcademy.com/lessons/dna-sequencing-techniques

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `DNA_n-${this.props.n}`, objClass: this});
  }

  render() {

      let {
        left,
        top,
      } = this.props;

      const {
        n,
        cursorBecomesMove,
        cursorBecomesPointer,
        dnaImg,
        hideToolTip,
        showToolTipFor,
        translatedLabels,
        isPedigree,
        pedigreeIsTall,
      } = this.props;

    if(n < 0) return null;

    const content = translatedLabels['DNA Tested'].translatedLabel;

    const pedigreeLeft = ( pedigreeIsTall ? 6.8: 4.8);
    left += (!isPedigree ? 11.5: pedigreeLeft);
    const pedigreeTop = ( pedigreeIsTall ? 15.8: 10.9);
    top += ( !isPedigree ? 23.8: pedigreeTop) + moveDown;

    let dim = {
      width: 8,
      height: 6,
    }

    const howmuch = ( pedigreeIsTall ? .9: .7);
    if(isPedigree) dim = shrinkDimBy({dim, howmuch})

    return <Image
      image={dnaImg}
      scaleX={.1}
      scaleY={.1}
      x={left}
      y={top}
      width={dim.width * 10 }
      height={dim.height * 10 }
      opacity={1}

      onTouchStart={(e)=>{}}

      onClick={()=>{

      }}

      onMouseenter={()=>{
        cursorBecomesPointer();

        let shift = {};

        if(!isPedigree){
          shift = {
            left: 9,
            top: -2,
          }
        } else {
          if(pedigreeIsTall){
            shift = {
              left: 5,
              top: -12,
            }
          } else {
            shift = {
              left: 2,
              top: -17,
            }

          }
        }

        showToolTipFor({
          node: n,
          placement: 'under',
          shiftLeftOnToolTip: shift.left,
          shiftTopOnToolTip: shift.top,
          bubbleWidth: 20,
          content,
        })
      }}
      onMouseleave={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}


    />;
  }
}


export class DnaBox extends React.Component {

  render () {

    let {
      n,
      left,
      top,
      isPedigree,
      pedigreeIsTall,
    } = this.props;

    if(n < 0) return null;

    let dim = {
      width: 9,
      height: 4,
    }

    const howmuch = ( pedigreeIsTall ? .9: .7);
    if(isPedigree) dim = shrinkDimBy({dim, howmuch})

    const pedigreeLeft = ( pedigreeIsTall ? 6.3: 4.4);
    left += (!isPedigree ? 11.5: pedigreeLeft);
    const pedigreeTop = ( pedigreeIsTall ? 16.8: 11.8);
    top += (!isPedigree ? 25: pedigreeTop) + moveDown;

    return  <Rect
              x={left}
              y={top}
              width={dim.width}
              height={dim.height}
              fill="black"
              opacity={1}
              perfectDrawEnabled={false}
              listening={false}
            />

  }
}

